import moment from 'moment';

import App from "../Core/App";


export default class Logger {
	constructor(pseudo = true) {
		this._pseudo = pseudo;
	}

	log(msg, ...args) {
		msg = moment().format("[DD/MMM/YYYY - HH:mm:ss] ") + msg;

		console.log(msg, args);
	}

	info(msg, ...args) {
		if( !this._pseudo ) console.info(msg, args);
		else this.log("[INFO] " + msg, args);
	}

	debug(msg, ...args) {
		if( !App.getInstance().DEBUG ) return;

		if( !this._pseudo ) console.debug(msg, args);
		else this.log("[DEBUG] " + msg, args);
	}
}